import axios from '@axios'

const state = () => ({
  items: [],
  unreadCount: 0,
  loading: false,
})

const getters = {
  userNotifications: s => s.items,
  userNotificationsUnreadCount: s => s.unreadCount,
  userNotificationsLoading: s => s.loading,
}

const mutations = {
  SET_USER_NOTIFICATIONS(state, { data, unreadCount }) {
    state.items = data
    state.unreadCount = unreadCount
  },
  SET_USER_NOTIFICATIONS_LOADING(state, value) {
    state.loading = value
  },
  MARK_USER_NOTIFICATION_READ(state, id) {
    const found = state.items.find(item => item.id === id)
    if (!found || found.is_read) return
    found.is_read = true
    state.unreadCount = Math.max(0, state.unreadCount - 1)
  },
  MARK_ALL_USER_NOTIFICATIONS_READ(state) {
    state.items.forEach(item => {
      item.is_read = true
    })
    state.unreadCount = 0
  },
}

const actions = {
  async fetchUserNotifications(context, { perPage = 10 } = {}) {
    context.commit('SET_USER_NOTIFICATIONS_LOADING', true)
    try {
      const response = await axios.get('/v1/user_notifications', {
        params: {
          by_column: { column: 'created_at', order: 'DESC' },
          meta: { pagination: { page: 1, per_page: perPage } },
        },
        skipErrorToast: true,
      })
      context.commit('SET_USER_NOTIFICATIONS', {
        data: response.data.data || [],
        unreadCount: response.data.is_unread_count || 0,
      })
      return response.data
    } finally {
      context.commit('SET_USER_NOTIFICATIONS_LOADING', false)
    }
  },

  async markUserNotificationRead(context, id) {
    context.commit('MARK_USER_NOTIFICATION_READ', id)
    await axios.post(`/v1/user_notifications/${id}/read`, {}, { skipErrorToast: true })
  },

  async markAllUserNotificationsRead(context) {
    context.commit('MARK_ALL_USER_NOTIFICATIONS_READ')
    await axios.post('/v1/user_notifications/read_all', {}, { skipErrorToast: true })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
